import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from '@xstyled/styled-components';
import { Button, Form, Radio } from 'antd';
import { Heading5, styleVariables } from '@lib/common';
import { useForm } from 'antd/lib/form/Form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledForm = styled(Form)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 1em;\n  width: 680px;\n  background-color: ", ";\n  border-radius: 10px;\n  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05);\n  h5 {\n    margin-bottom: 0;\n  }\n"])), styleVariables.colors.gray1);
var formItemLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 18
  }
};
var StyledStatusOptions = styled(Radio.Button)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 9px;\n"])));
var StyledClearForm = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  text-align: end;\n"])));
export function FilterForm(_ref) {
  var assignmentConfigs = _ref.assignmentConfigs,
      handleFilter = _ref.handleFilter,
      onReset = _ref.onReset,
      translation = _ref.translation;

  var _useForm = useForm(),
      _useForm2 = _slicedToArray(_useForm, 1),
      form = _useForm2[0];

  var types = assignmentConfigs.types,
      status = assignmentConfigs.status;

  var handleChangeFilter = function handleChangeFilter(_, value) {
    handleFilter(value);
  };

  var onResetForm = function onResetForm() {
    form.resetFields();
    onReset();
  };

  return /*#__PURE__*/_jsxs(StyledForm, _objectSpread(_objectSpread({
    form: form
  }, formItemLayout), {}, {
    onValuesChange: handleChangeFilter,
    children: [/*#__PURE__*/_jsx(StyledClearForm, {
      children: /*#__PURE__*/_jsx(Button, {
        onClick: onResetForm,
        type: "link",
        children: "Clear All"
      })
    }), /*#__PURE__*/_jsx(Form.Item, {
      label: /*#__PURE__*/_jsx(Heading5, {
        children: translation('typeExercise')
      }),
      colon: false,
      name: "type",
      children: /*#__PURE__*/_jsx(Radio.Group, {
        optionType: "button",
        buttonStyle: "solid",
        children: types === null || types === void 0 ? void 0 : types.map(function (type) {
          return /*#__PURE__*/_jsx(Radio.Button, {
            value: type.id,
            children: type.name
          }, type.id);
        })
      })
    }), /*#__PURE__*/_jsx(Form.Item, {
      label: /*#__PURE__*/_jsx(Heading5, {
        children: translation('status')
      }),
      colon: false,
      name: "status",
      children: /*#__PURE__*/_jsx(Radio.Group, {
        optionType: "button",
        buttonStyle: "solid",
        children: status === null || status === void 0 ? void 0 : status.map(function (state) {
          return state.name && /*#__PURE__*/_jsx(StyledStatusOptions, {
            value: state.id,
            children: state.name
          }, state.id);
        })
      })
    })]
  }));
}